export const sendTextMessage = (phoneNumber: string, message: string, currentDevice: string) => {
  const smsString =
    'sms:' +
    phoneNumber +
    (currentDevice == 'ios' ? '&' : '?') +
    'body=' +
    encodeURIComponent(message);
  return smsString;
};
